import { AxiosResponse } from "axios";
import { axiosInstance } from "./common";

export interface IAnalyticsOverview {
  cases_opened: number;
  fraud_amount: number;
  cases_declared_fraud: number;
  cases_declared_no_fraud: number;
  cases_in_progress: number;
  cases_open: number;
  cases_deactivated: number;
  cases_closed: number;
}

export interface IIncidentMetrics {
  total_cases_opened: number;
  total_fraud_amount?: number;
}

export interface IIncidentsInZone {
  zone: string;
  metrics: IIncidentMetrics;
}

export interface IIncidentsByZone {
  zones: IIncidentsInZone[];
}

export interface IIncidentsInBranch {
  branch: string;
  metrics: IIncidentMetrics;
}

export interface IIncidentsByBranch {
  branches: IIncidentsInBranch[];
}

export interface IIncidentsInFraudType {
  fraud_type: string;
  metrics: IIncidentMetrics;
}

export interface IIncidentsByFraudType {
  fraud_types: IIncidentsInFraudType[];
}

export interface IIncidentsInFraudNature {
  nature_of_fraud: string;
  metrics: IIncidentMetrics;
}

export interface IIncidentsByFraudNature {
  nature_of_fraud: IIncidentsInFraudNature[];
}

export interface IIncidentsInMonth {
  month: string;
  year: string;
  metrics: IIncidentMetrics;
}

export interface IIncidentsByMonth {
  month: IIncidentsInMonth[];
}

export interface IGetDashboardResponse {
  analytics_overview?: IAnalyticsOverview;
  incidents_by_zone?: IIncidentsByZone;
  incidents_by_branch?: IIncidentsByBranch;
  incidents_by_fraud_type?: IIncidentsByFraudType;
  incidents_by_nature_of_fraud?: IIncidentsByFraudNature;
  incidents_by_month?: IIncidentsByMonth;
}

export interface IDashboardRequestPayload {
  start_date?: string;
  end_date?: string;
}


const DashboardAPI = {
  getMetrics: async (params?: IDashboardRequestPayload) => {
    const response: AxiosResponse<IGetDashboardResponse> =
      await axiosInstance.get("/v1/dashboard/metrics", {
        params,
        paramsSerializer: {
          indexes: null,
        },
      });
    return response.data;
  },
};

export default DashboardAPI;
